
    import "src/app/AppAdmin/Brands/WSIN/utils.module.scss?farm_css_modules";
    
    export default {"flexCenter": `flexCenter-fad20f06`,"searchContainer": `searchContainer-fad20f06`,"searchInput": `searchInput-fad20f06`,"skuDetail": `skuDetail-fad20f06`,"sub": `sub-fad20f06`,"topFilter": `topFilter-fad20f06`,"topLeftFilter": `topLeftFilter-fad20f06`,"topRightFilter": `topRightFilter-fad20f06`,"wrapper": `wrapper-fad20f06`}
    